import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/pregnancy-due-date',
  component: () => import('../../routes/PregnancyDueDate.svelte'),
  card: {
    id: 'pregnancy-due-date',
    title: 'Pregnancy Due Date Calculator',
    description: 'Calculate your estimated due date based on your last menstrual period (LMP) using Naegele\'s Rule.',
    icon: 'child_care',
    iconBgClass: 'bg-pink-50',
    iconTextClass: 'text-pink-600',
    href: '/pregnancy-due-date',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Pregnancy Due Date Calculator – Free EDD Estimator',
    description: 'Free pregnancy due date calculator using Naegele\'s Rule. Enter your last menstrual period (LMP) to estimate your due date, current pregnancy week, and key milestones.',
  },
};

export default meta;
